import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _ from 'lodash';
import Promise from 'bluebird';
import $ from 'jquery';
import Progress from '../components/ui/react-ui/progress.jsx';
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg,
    session = initialState.sessionObj;

var log = require('loglevel').getLogger('ajax-helper');

Promise.config({
  cancellation: true,
  // Enables all warnings except forgotten return statements.
  warnings: {
    wForgottenReturn: false
  }
});

function createJqXHR(options) {
  var defaultOptions = {
    dataType: 'json',
    contentType: 'application/json',
    cache: false,
    complete: function complete(jqXHR, textStatus) {
      if (jqXHR.responseText === 'timeout' || textStatus === 'parsererror') window.location.replace(cfg.contextRoot + '/login');
    }
  };
  return $.ajax(_.merge(defaultOptions, options));
}

function send(options) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var jqxhr = createJqXHR(options);
  !noProgress && Progress.startSpin();
  return Promise.resolve(jqxhr).then(function (res) {
    !noProgress && Progress.done();
    return res;
  }).catch(function (xhr) {
    log.error(xhr);
    !noProgress && Progress.done();
    return xhr;
  });
}

function get(url, data, options) {
  var noProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return send(_objectSpread({
    url: url,
    method: 'get',
    data: data
  }, options), noProgress);
}

function post(url, data, options) {
  var noProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return send(_objectSpread({
    url: url,
    method: 'post',
    data: data
  }, options), noProgress);
}

function put(url, data, options) {
  var noProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return send(_objectSpread({
    url: url,
    method: 'put',
    data: data
  }, options), noProgress);
}

function deleteRequest(url, data, options) {
  var noProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return send(_objectSpread({
    url: url,
    method: 'delete',
    data: data
  }, options), noProgress);
}

function param(params) {
  return $.param(params);
}

function loadImage(src) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  !noProgress && Progress.startSpin();
  var promise = new Promise(function (resolve, reject) {
    var img = document.createElement('img');
    img.addEventListener('load', function () {
      resolve(img);
    });
    img.addEventListener('error', function (err) {
      reject(new Error(err));
    });
    img.src = src;
  });
  return promise.then(function (img) {
    !noProgress && Progress.done();
    return img;
  }, function (err) {
    !noProgress && Progress.done();
    return null;
  });
}

export default {
  send: send,
  get: get,
  post: post,
  put: put,
  deleteRequest: deleteRequest,
  param: param,
  loadImage: loadImage
};